import React, { useCallback, useEffect, useState } from 'react'
import Input from '../../../../components/input/Input';
import Table from '../../../../components/table/Table';
import Label from '../../../../components/title/label';
import Layout from './Layout'
import axios from 'axios';
import {BsPencil} from 'react-icons/bs'
import { RiDeleteBinLine } from 'react-icons/ri'
import { Button } from '../../../../components/button/button';
import { Navbar } from '../../../../components/navbar/Navbar';
import Modal from '../../../../components/modals/Modal';
import ReactSelect from 'react-select';
import Checkbox from '../../../../components/button/Checkbox';
import { useLocation } from 'react-router-dom';
import { BACKEND_URL } from '../../../../constants/constant';
function DateEcheancePeriode() {

  const [filteredData, setFilteredData] = useState([]);
  //const [searchCode, setSearchCode] = useState('');

  const [dataCodeContent, setDataCodeContent] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEditData, setSelectedEditData] = useState(null);
  const [isModalOpenModifi, setIsModalOpenModifi] = useState(false);
  const [numero_impot , setNumero_impot] = useState('');
  const [paye_impot , setPaye_impot ] = useState('');
  const [paye_penalite , setPaye_penalite] = useState('');
  const [paye_amende , setPaye_amende] = useState('');
  const [valeur_amende , setValeur_amende] = useState('');
  const [taux_penalite , setTaux_penalite] = useState('');
  const [dataCodeImpot, setDataCodeImpot] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  //const [selectedExercice, setSelectedExercice] = useState(null); 
  const [periode , setPeriode ] = useState('');
  const [periode1 , setPeriode1] = useState('');
  const [periode2 , setPeriode2] = useState('');
  const [annee , setAnnee] = useState('');
//checkbox event



 //code Impot
 const [selectedNumeroImpot, setSelectedNumeroImpot] = useState(null);
 const [selectedNumeroImpotModifi, setSelectedNumeroImpotModifi] = useState(null);
 

// Dans useEffect, vérifiez que vous avez bien des données avant de filtrer
// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const [revenusResponse, impotResponse] = await Promise.all([
//         axios.get(`${BACKEND_URL}/code/revenusalariaux`),
//         axios.get(`${BACKEND_URL}/code/impot`)
//       ]);
//       if (revenusResponse.data && impotResponse.data) {
//         setDataCodeContent(revenusResponse.data);
//         setDataCodeImpot(impotResponse.data);
//       }
//     } catch (error) {
//       console.error('Erreur lors de la récupération des données', error);
//     }
//   };

//   fetchData();
// }, []);

useEffect(() => {

  // Récupérer les données depuis le backend
  axios.get(`${BACKEND_URL}/code/impot`)
    .then((response) => setDataCodeImpot(response.data))
    .catch((error) => console.error(error));
}, []);


useEffect(() => {

  // Récupérer les données depuis le backend
  axios.get(`${BACKEND_URL}/code/revenusalariaux`)
    .then((response) => setDataCodeContent(response.data))
    .catch((error) => console.error(error));
}, []);


useEffect(() => {
  const results = Array.isArray(dataCodeContent) ? dataCodeContent.filter((item) => {
    return (item.numero_impot && item.numero_impot.toString().includes(searchTerm)) || 
           (item.libelle && item.libelle.toLowerCase().includes(searchTerm.toLowerCase()));
  }) : [];  // Si ce n'est pas un tableau, on initialise un tableau vide
  setFilteredData(results);
}, [searchTerm, dataCodeContent]);


  const handleSelectChange = (selectedOption) => {
    // Mettre à jour l'état avec le numéro d'impôt sélectionné
    setSelectedNumeroImpot(selectedOption.value);
    setNumero_impot(selectedOption.value);
    
  };
  

  
  



  const handleSelectChangeModifi = (selectedOption) => {
    // Mettre à jour l'état avec le numéro d'impôt sélectionné
    setSelectedNumeroImpotModifi(selectedOption.value);
    setSelectedEditData((prevData) => ({
      ...prevData,
      numero_impot : selectedOption.value,
    }));
    
  };
  
   // Rechercher le libellé correspondant au numéro d'impôt sélectionné
 const selectedLibelle = dataCodeImpot.find((item) => item.numero_impot === selectedNumeroImpot);
 const selectedLibelleModifi = dataCodeImpot.find((item) => item.numero_impot === selectedNumeroImpotModifi);
 
  


  
 const handleDelete = async (id) => {
  try {
    await axios.delete(`${BACKEND_URL}/code/revenusalariaux/${id}`);
    setDataCodeContent((prevData) => prevData.filter(item => item.id !== id));
  } catch (error) {
    console.error('Erreur lors de la suppression des données :', error);
  }
};


const DataHandler = useCallback(
  async (e) => {
    e.preventDefault();

    if (!numero_impot || !annee || !periode || !selectedLibelle?.libelle) {
      console.error("Certains champs obligatoires sont manquants.");
      return;
    }

    const Data = {
      "numero_impot":numero_impot,
      "paye_impot":paye_impot,
      "paye_amende":paye_amende,
      "paye_penalite":paye_penalite,
      "valeur_amende":valeur_amende,
      "taux_penalite":taux_penalite,
      "annee":annee,
      "periode":periode,
      "periode1":periode1,
      "periode2":periode2,
      "libelle": selectedLibelle.libelle,
    };

    console.log("Valeur envoyée :", Data);

    try {
      const response = await axios.post(`${BACKEND_URL}/code/revenusalariaux`, Data);
      setDataCodeContent(response.data);
      console.log("Données ajoutées avec succès :", Data);
      setIsModalOpen(false);
      window.location.reload();
    } catch (error) {
      console.error("Erreur lors de l'ajout des données :", error);
    }
  },
  [numero_impot, paye_impot, paye_amende, paye_penalite, valeur_amende, taux_penalite, annee, periode, periode1, periode2, selectedLibelle, setDataCodeContent, setIsModalOpen]
);


  console.log(filteredData)
  const headers = [
    'Num', 
    'Libellé', 
    "Payé Impot",
    'Payé Amande', 
    'Payé Pénalité', 
    'Valeur Amende', 
    'Taux Pénalité', 
    "Année", 
    "Période" , 
    "Période 1", 
    "Période 2",
    'Supression', 
    'Modification'
  ];

  
  const data = filteredData.length > 0 
  ? filteredData.map((item) => [
      item.numero_impot,
      item.libelle,
      item.paye_impot,
      <Checkbox key={`check-amende-${item.id}`} checked={item.paye_amende} />,
      <Checkbox key={`check-penalite-${item.id}`} checked={item.paye_penalite} />,
      item.valeur_amende,
      item.taux_penalite,
      item.annee,
      item.periode,
      item.periode1,
      item.periode2,
      <button
        key={`delete-${item.id}`}
        className="cursor-pointer"
        onClick={() => handleDelete(item.id)}
      >
        <RiDeleteBinLine />
      </button>,
      <button
        key={`edit-${item.id}`}
        className="cursor-pointer"
        onClick={() => {
          setSelectedEditData(item);
          setIsModalOpenModifi(true);
        }}
      >
        <BsPencil />
      </button>
    ])
  : [["Aucune " , "Aucune" ,"Aucune " , "Aucune","Aucune " , "Aucune","Aucune " , "Aucune","Aucune " , "Aucune","Aucune " , "Aucune","Aucune " ]];


/*// Créez une fonction de filtrage
const filterDataByExercice = () => {
  if (selectedExercice) {
    const filtered = data.filter((item) => item[6] === selectedExercice.value);
    setFilteredData(filtered);
  } else {
    setFilteredData(data);
  }
};

// Utilisez cette fonction dans un useEffect avec selectedExercice comme dépendance
useEffect(() => {
  filterDataByExercice();
}, [selectedExercice]);
*/


const handleUpdate = useCallback(async () => {
  if (!selectedEditData?.id) {
    console.error("Aucune donnée sélectionnée pour la modification.");
    return;
  }

const DataUpdate = {
  "numero_impot": selectedEditData.numero_impot,
  "paye_impot": selectedEditData.paye_impot,
  "paye_amende": selectedEditData.paye_amende,
  "paye_penalite": selectedEditData.paye_penalite,
  "valeur_amende": selectedEditData.valeur_amende,
  "taux_penalite": selectedEditData.taux_penalite,
  "annee": selectedEditData.annee,
  "periode": selectedEditData.periode,
  "periode1": selectedEditData.periode1,
  "periode2": selectedEditData.periode2,
  "libelle": selectedLibelleModifi.libelle,

}

console.log("Données à mettre à jour :", selectedEditData.id);
  try {
    // Mise à jour des données dans la base de données
    await axios.put(
      `${BACKEND_URL}/code/revenusalariaux/${selectedEditData.id}`,
      DataUpdate
    );

    // Fermeture du modal et réinitialisation des données sélectionnées
    setIsModalOpenModifi(false);
    setDataCodeContent((prevData) =>
      prevData.map((item) =>
        item.id === selectedEditData.id ? { ...item, ...DataUpdate } : item
      )
    );   
    console.log("Données mises à jour avec succès.");
  } catch (error) {
    console.error("Erreur lors de la mise à jour des données :", error.response?.data || error.message);
  }
}, [selectedEditData, setIsModalOpenModifi , selectedLibelleModifi]);

   
  const NavbarModal =(
    <div className='text-white'>
    Date écheance par période
  </div>
  
  )
 
  const content = (
    <div >
     
     <Input
          type="text"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mb-4 ml-4 w-64"
        />
        

            <Button children="Ajouter une information" onClick={() => setIsModalOpen(true)} className="m-4" ></Button>
            <Button children="Actualiser" onClick={() => window.location.reload()} className="m-4" ></Button>
      <div className='mt-10 m-4' >
      
      <Table headers={headers} data={data} ></Table>
      </div>
      <Modal  isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} className="w-[620px] h-[670px]">
        <form >
    <Navbar content={NavbarModal} ></Navbar>
    <div className=' m-4 flex justify-between' >
<Label text=" Numéro Impot :" className="mt-2"></Label>
<ReactSelect
  options={dataCodeImpot.map((item) => ({
    value: item.numero_impot,
    label: item.numero_impot,
  }))}
  value={dataCodeImpot.find((option) => option.value === numero_impot)}
  onChange={handleSelectChange}
  className="ml-4 w-40"
/>
    </div>
    <div className=' m-4 flex justify-between' >
<Label text=" Payé Impot :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
 value={paye_impot}
 onChange={(e)=> setPaye_impot(e.target.value)}
></Input>
    </div>
    <div className=' m-4 flex justify-between' >
    <Checkbox 
  label="Payé Pénalité" 
  className="m-4"
  checked={paye_penalite} 
  onChange={(checked) => setPaye_penalite(checked)}
/>
<Checkbox 
  label="Payé Amende" 
  className="m-4"
  checked={paye_amende} 
  onChange={(checked) => setPaye_amende(checked)}
/>
    </div>
    <div className=' m-4 flex justify-between' >
<Label text=" Valeur Amande :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
 value={valeur_amende}
 onChange={(e)=> setValeur_amende(e.target.value)}
 ></Input>
    </div>
    <div className=' m-4 flex justify-between' >
<Label text=" Taux Pénalité :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
 value={taux_penalite}
 onChange={(e)=> setTaux_penalite(e.target.value)}
 ></Input>
    </div> 
    <div className=' m-4 flex justify-between' >
<Label text=" Periode :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
 value={periode}
 onChange={(e)=> setPeriode(e.target.value)}
 ></Input>
    </div>
    <div className=' m-4 flex justify-between' >
<Label text=" Periode 1 :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
 value={periode1}
 onChange={(e)=> setPeriode1(e.target.value)}
 ></Input>
    </div>
    <div className=' m-4 flex justify-between' >
<Label text=" Periode 2 :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
 value={periode2}
 onChange={(e)=> setPeriode2(e.target.value)}
 ></Input>
    </div>
    <div className=' m-4 flex justify-between' >
<Label text=" Annee :" className="mt-2"></Label>
<Input type="number"  className="ml-4"
 value={annee}
 onChange={(e)=> setAnnee(e.target.value)}
 ></Input>
    </div>    
    <p className='text-white text-m m-4'>{selectedLibelle ? selectedLibelle.libelle : ''}</p>
    <div className="flex justify-between m-4">

  <Button children="Enregistrer"
 type='submit'
 onClick={DataHandler}
  ></Button>
  <Button onClick={() =>  setIsModalOpen(false)} children="Quitter"  ></Button>
  </div>
  </form>
    </Modal>
    <Modal  isOpen={isModalOpenModifi} onClose={() => setIsModalOpenModifi(false)} className="w-[620px] h-[700px] p-4">
    <Navbar content={NavbarModal} ></Navbar>
    <div className=' mt-2 flex justify-between' >
<Label text=" Numéro Impot :" className="mt-2"></Label>
<ReactSelect
  options={dataCodeImpot.map((item) => ({
    value: item.numero_impot,
    label: item.numero_impot,
  }))}
  value={dataCodeImpot
    .map((item) => ({ value: item.numero_impot, label: item.numero_impot }))
    .find((option) => option.value === selectedEditData?.numero_impot)
  }
  onChange={handleSelectChangeModifi}
  className="w-40"
/>


    </div>
    <div className=' mt-2 flex justify-between' >
<Label text=" Payé Impot :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
  value={selectedEditData ? selectedEditData.paye_impot : ''}
  onChange={(e) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      paye_impot: e.target.value,
    }))
  }
></Input>
    </div>
    <div className=' mt-2 flex justify-between' >
    <Checkbox 
  label="Payé Pénalité" 
  checked={selectedEditData ? selectedEditData.paye_penalite : false}  // Ici, paye_penalite doit être utilisé
  onChange={(checked) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      paye_penalite: checked,  // Ici aussi, il faut mettre à jour 'paye_penalite'
    }))
  }
/>
<Checkbox 
  label="Payé Amende" 
  checked={selectedEditData ? selectedEditData.paye_amende : false} // Ici, paye_amende doit être utilisé
  onChange={(checked) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      paye_amende: checked, 
    }))
  }
/>

    </div>

    <div className=' mt-4 flex justify-between' >
<Label text=" Taux pénalité :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
  value={selectedEditData ? selectedEditData.taux_penalite : ''}
  onChange={(e) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      taux_penalite: e.target.value,
    }))
  }
 ></Input>
    </div>
    <div className=' mt-4 flex justify-between' >
<Label text=" Valeur amende :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
  value={selectedEditData ? selectedEditData.valeur_amende : ''}
  onChange={(e) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      valeur_amende: e.target.value,
    }))
  }
 ></Input>
    </div> 
    <div className=' mt-4 flex justify-between' >
<Label text=" Periode :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
  value={selectedEditData ? selectedEditData.periode : ''}
  onChange={(e) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      periode: e.target.value,
    }))
  }
 ></Input>
    </div> 
    <div className=' mt-4 flex justify-between' >
<Label text=" Période 1 :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
  value={selectedEditData ? selectedEditData.periode1 : ''}
  onChange={(e) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      periode1: e.target.value,
    }))
  }
 ></Input>
    </div> 
    <div className=' mt-4 flex justify-between' >
<Label text=" Période 2 :" className="mt-2"></Label>
<Input type="text"  className="ml-4"
  value={selectedEditData ? selectedEditData.periode2 : ''}
  onChange={(e) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      periode2: e.target.value,
    }))
  }
 ></Input>
    </div> 
    <div className=' mt-4 flex justify-between' >
<Label text=" Annnée :" className="mt-2"></Label>
<Input type="number"  className="ml-4"
  value={selectedEditData ? selectedEditData.annee : ''}
  onChange={(e) =>
    setSelectedEditData((prevData) => ({
      ...prevData,
      annee: e.target.value,
    }))
  }
 ></Input>
    </div> 
    
    <p className='text-white text-xl m-4'>{selectedLibelleModifi ? selectedLibelleModifi.libelle : ''}</p>
    <div className="flex justify-between p-4">

  <Button children="Modifier"
 onClick={handleUpdate}
  ></Button>
  <Button onClick={() =>  setIsModalOpenModifi(false)} children="Quitter"  ></Button>
  </div>
    </Modal>
    </div>
  );
  const location = useLocation();
return (
 <Layout children={content} currentPath={location.pathname}>

 </Layout>
  )
}

export default DateEcheancePeriode